import { MaybeLoaded } from 'json-react-layouts-data-loader'

import { Props } from 'component-library/cards/Portrait/Portrait'
import { CommonCardProps } from '../CardItem.Props'
import { PublicationCardItem } from 'common/client-data-types/card-types'

type CommonLayoutProps = Omit<Props, 'cardNumber' | 'item' | 'onEvent'>
export interface LandscapeStackedLayout {
    type: 'landscape-stacked'
    format: CommonLayoutProps | 'landscape-stacked-common' | 'landscape-stacked-noteaser'
}

export const commonLandscapeStackedProps: CommonLayoutProps = {
    hideTeaser: false,
}

export const noTeaserLandscapeStackedProps: CommonLayoutProps = {
    hideTeaser: true,
}

const layoutProps: { [formatName: string]: CommonLayoutProps } = {
    'landscape-stacked-common': commonLandscapeStackedProps,
    'landscape-stacked-noteaser': noTeaserLandscapeStackedProps,
}

function getPropsForLayout(layout: LandscapeStackedLayout): CommonLayoutProps {
    if (typeof layout.format === 'object') {
        return layout.format
    }

    return layoutProps[layout.format]
}

export const getLandscapeStackedCardItemProps = (
    item: MaybeLoaded<PublicationCardItem>,
    layout: LandscapeStackedLayout,
    props: CommonCardProps,
    cardNumber: number
) => {
    const commonProps: CommonLayoutProps = getPropsForLayout(layout)

    const loadedProps: Props = {
        ...commonProps,
        ...props,
        item,
        cardNumber,
    }

    return loadedProps
}
